export const addPetMain = {
    addPetMainChoosePet: {
        rbmail: {
            type: 'display',
            id: '144165961',
        },
    },
    addPetMainAddCat: {
        rbmail: {
            type: 'display',
            id: '144165963',
        },
    },
    addPetMainAddDog: {
        rbmail: {
            type: 'display',
            id: '144165965',
        },
    },
    addPetMainAddInfo: {
        rbmail: {
            type: 'display',
            id: '144165975',
        },
    },
    addPetMainLastSlideCat: {
        rbmail: {
            type: 'display',
            id: '144165978',
        },
    },
    addPetMainLastSlideDog: {
        rbmail: {
            type: 'display',
            id: '144165982',
        },
    },
} as const;
